// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"y8-z"};